import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import CloseFeedbackDetailsWithStar from "./form-component/feedback-form/CloseFeedbackDetailsWithStar";
import DropdownInputWithLabel from "./DropdownInputWithLabel";
import { TextField } from "@mui/material";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { apiHostUrl, getSubQuestion } from "../../../constants/constants";
import SurveyCheckBox from "./SurveyCheckBox";
import SurveyRadioCheck from "./SurveyRadioCheck";
import SurveyDropDown from "./SurveyDropDown";
import SurveyMultiSelectDropdown from "./SurveyMultiSelectDropdown";
import SurveyDynamicDropDown from "./SurveyDynamicDropDown";
import SurveyDynamicCheckBox from "./SurveyDynamicCheckBox";
import SurveyDynamicRadioButton from "./SurveyDynamicRadioButton";
import SurveyDynamicMultipleDropDown from "./SurveyDynamicMultipleDropDown";
import TextLabel from "./TextLabel";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';
import SurveyQuestionnaires from "./SurveyQuestionnaires";

export default function SurveyStarRating(props) {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState(props.question);
  console.log(question.optionList);

  // const colorMap = { 1: "#FF5454", 2: "#FF5454", 3: "#F6AD35", 4: "#73B58D", 5: "#73B58D" };
  const dataListforRating=[];
  const totalOptions = question.optionList.length;
  for(var i=0; i<totalOptions; i++){
    var currOption=question.optionList[i];
    dataListforRating.push({"value": currOption.id, "label": currOption.label, "colorCode": currOption.colorCode});
    // var currSequence = currOption.optionSequenceNo;
    // dataListforRating.push({"value": currOption.id, "label": currSequence+"/"+totalOptions, "colorCode": colorMap[currSequence]});
  }
  const [satisfactionLevel, setSatisfactionLevel] = useState(-1);
  const [remarks, setRemarks] = useState("");
  const { csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const [headers, setHeaders] = useState({
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  });
  const [subQuestions, setSubQuestions] = useState([]);
  const [starPayload, setStarPayload] = useState({
    id: question.id,
    remark: null
  });
  const [response, setResponse] = useState();
  const getSubQuestionURL = apiHostUrl + getSubQuestion;
  const [showRemark, setShowRemark] = useState(false);
  const [remarkMandatory, setRemarkMandatory] = useState(false);
  const [RemarkBoxLabel, setRemarkBoxLabel] = useState('Remark');
  console.log(getSubQuestionURL);
  // Function to handle change in satisfaction level
  const handleSatisfactionChange = (newValue) => {
    debugger;
    console.log(newValue);
    var unSelectedOptions = [];
    question.optionList.forEach(x => {if(x.id !== newValue) {unSelectedOptions.push(x.id);}});

    var selectedOption = question.optionList.find(x => x.id === newValue);
    setShowRemark(selectedOption?.showRemark || false);
    setRemarkMandatory(selectedOption?.remarkMandatory || false);
    setRemarkBoxLabel(selectedOption?.remarkBoxLabel || 'Remark');
    const selectedOptionId = selectedOption?.id;
    console.log(selectedOption?.showRemark);
    setSatisfactionLevel(newValue);

    var payload = {
        id: question.id
    };

    if(newValue && parseInt(newValue) > 0){
        payload = {
            id: question.id,
            answerList: [{
                questionOptionId: parseInt(newValue),
                remark: showRemark ? remarks : null
            }]
        };
    }

    setStarPayload(payload);

    props.addRemoveSubQuestions(selectedOptionId, subQuestions, unSelectedOptions);

  };

  // Function to handle change in remarks
  const handleRemarksChange = (e) => {
    //debugger;
    const { value } = e.target;
    setRemarks(value);
    setStarPayload((prev) => ({
        //...prev,
        id: question.id,
        answerList: [{
          questionOptionId: prev.answerList[0].questionOptionId,
          remark: value
        }]
    }));
  };

  useEffect(() => {
    console.log(showRemark);
  }, [showRemark]);

  const handleCheckboxChange = (payload) => {
    console.log(payload);
    dispatch(setQuestionAnswerList(payload));
  };

  useEffect(() => {
    dispatch(setQuestionAnswerList(starPayload));
  }, [starPayload]);

  console.log(subQuestions);

  return (
    <>
      <CloseFeedbackDetailsWithStar
        defaultValue={null}
        dataListforRating={dataListforRating}
        onSatisfactionChange={handleSatisfactionChange}
      />

      <SurveyQuestionnaires questions={subQuestions} mode={5}/>

      {showRemark && (
        <>
          <Form.Label className="fs-6 fw-medium">
            {/* <TextLabel
              title={RemarkBoxLabel }
              {...(remarkMandatory ? { isMandatory: true } : {})}
            /> */}
          </Form.Label>
          <Form.Control
            as="textarea"
            aria-label="empty textarea"
            placeholder="Remark"
            minRows={3}
            maxRows={5}
            style={{ width: "100%", marginTop: "8px" }}
            onChange={handleRemarksChange}
            value={remarks}
          />
        </>
      )}
    </>
  );
}
